import { render, staticRenderFns } from "./RolesCreate.vue?vue&type=template&id=a877aea0"
import script from "./RolesCreate.vue?vue&type=script&lang=js"
export * from "./RolesCreate.vue?vue&type=script&lang=js"
import style0 from "./RolesCreate.vue?vue&type=style&index=0&id=a877aea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports